module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("aTgJp"))).then(() => parcelRequire('8O0s3'));